import axios from 'axios'

const UNAUTHORIZED = 401
const PAGENOTFOUND = 404
const INVALID_TOKEN = 'Invalid token'
const instance = axios.create({
  baseURL: 'https://jurnalamari-api.pptik.id:5023/'
})

function checkLocalStorage () {
  const loggedInToken = localStorage.getItem('token')
  const loggedInRole = localStorage.getItem('role')
  if (!loggedInRole || !loggedInToken) {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    location.reload()
  }
}

instance.interceptors.response.use(function (response) {
  checkLocalStorage()
  return response
}, function (error) {
  const { status } = error.response
  const responseMessage = error.response.data.message

  if (status === UNAUTHORIZED && responseMessage === INVALID_TOKEN) {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    location.reload()
  } else if (status === PAGENOTFOUND) {
    this.$router.push('PageError')
  }
  checkLocalStorage()
  return Promise.reject(error)
}
)

export default () => {
  return instance
}



// WEBPACK FOOTER //
// ./src/services/Api.js